import { useTranslation } from "@/hooks/useTranslation";
import { TeamKnowledgeFileDTO } from "@shaarp/common";
import { DataTable } from "../data-table/data-table";
import { dataTableTeamKnowledgeFilesColumns } from "./data-table-team-knowledge-files-columns";

export default function DataTableTeamKnowledgeFiles({
  files,
  isLoading,
  onDelete,
}: {
  files: TeamKnowledgeFileDTO[];
  isLoading: boolean;
  onDelete?: (file: TeamKnowledgeFileDTO) => void;
}) {
  const { t } = useTranslation();

  return (
    <DataTable
      data={files}
      columns={dataTableTeamKnowledgeFilesColumns(t, onDelete)}
      columnsPersistenceKey="data-table-team-knowledge-files"
      emptyText={t("team.knowledge.dataTable.emptyTextFiles")}
      isLoading={isLoading}
      sortingState={[{ id: "updatedAt", desc: true }]}
      showFilter={false}
    />
  );
}
